
export const TimeSelectionModal = () => `
    <div id="time-selection-modal" class="modal-overlay hidden">
        <div class="modal-content glass-panel slide-up-animation">
            <h2 class="modal-title">SÜREYİ SEÇ</h2>
            <div class="time-options-grid">
                <button class="gaddar-btn time-btn fast" data-time="15">
                    <span class="icon">⚡</span>
                    <span class="label">15 SANİYE</span>
                    <small>Hızlı ve Öfkeli</small>
                </button>
                <button class="gaddar-btn time-btn medium" data-time="30">
                    <span class="icon">⏱️</span>
                    <span class="label">30 SANİYE</span>
                    <small>İdeal Denge</small>
                </button>
                <button class="gaddar-btn time-btn slow" data-time="45">
                    <span class="icon">🐢</span>
                    <span class="label">45 SANİYE</span>
                    <small>Rahat Rahat</small>
                </button>
            </div>
            <button id="close-time-modal-btn" class="gaddar-btn secondary mini" style="margin-top: 1rem;">İPTAL</button>
        </div>
    </div>
    
    <style>
        #time-selection-modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex; /* Hidden class overrides this to none */
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.8);
            backdrop-filter: blur(5px);
            z-index: 2000;
        }

        #time-selection-modal.hidden {
            display: none !important;
        }

        .slide-up-animation {
            animation: slideUp 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
            transform-origin: bottom;
        }

        @keyframes slideUp {
            from {
                opacity: 0;
                transform: translateY(100px) scale(0.9);
            }
            to {
                opacity: 1;
                transform: translateY(0) scale(1);
            }
        }

        .time-options-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 1.5rem;
            margin: 2rem 0;
        }
        
        .time-btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 10px;
            padding: 2rem 1.5rem;
            border-radius: 20px;
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
            border: 2px solid rgba(255,255,255,0.1);
        }
        
        .time-btn:hover {
            transform: translateY(-5px) scale(1.05);
            box-shadow: 0 10px 20px rgba(0,0,0,0.4);
        }

        .time-btn .icon {
            font-size: 2.5rem;
            margin-bottom: 5px;
            filter: drop-shadow(0 0 10px rgba(0,0,0,0.5));
        }

        .time-btn .label {
            font-size: 1.2rem;
            font-weight: 800;
            text-shadow: 0 2px 4px rgba(0,0,0,0.8);
        }

        .time-btn small {
            opacity: 0.9;
            font-size: 0.8rem;
            font-weight: 500;
            color: rgba(255,255,255,0.8);
        }

        /* Renkler */
        .time-btn.fast {
            background: linear-gradient(135deg, #ff5252, #b71c1c);
            box-shadow: 0 0 20px rgba(255, 82, 82, 0.3);
            border-color: #ff8a80;
        }
        .time-btn.fast:hover { margin-top: -10px; box-shadow: 0 0 30px rgba(255, 82, 82, 0.6); }

        .time-btn.medium {
            background: linear-gradient(135deg, #ff9800, #e65100);
            box-shadow: 0 0 20px rgba(255, 152, 0, 0.3);
            border-color: #ffd180;
        }
        .time-btn.medium:hover { margin-top: -10px; box-shadow: 0 0 30px rgba(255, 152, 0, 0.6); }

        .time-btn.slow {
            background: linear-gradient(135deg, #4caf50, #1b5e20);
            box-shadow: 0 0 20px rgba(76, 175, 80, 0.3);
            border-color: #a5d6a7;
        }
        .time-btn.slow:hover { margin-top: -10px; box-shadow: 0 0 30px rgba(76, 175, 80, 0.6); }
        
        @media (max-width: 600px) {
            .time-options-grid {
                grid-template-columns: 1fr;
            }
        }
    </style>
`;
